var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.2143cd098ab1eae1824a343aae03888e.svg#P';
                    var viewUrl = 'sprites.2143cd098ab1eae1824a343aae03888e.svg#view-P';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 17',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };